import { render, staticRenderFns } from "./accounting-invoices.vue?vue&type=template&id=81615f52&scoped=true"
import script from "./accounting-invoices.vue?vue&type=script&lang=js"
export * from "./accounting-invoices.vue?vue&type=script&lang=js"
import style0 from "./accounting-invoices.vue?vue&type=style&index=0&id=81615f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81615f52",
  null
  
)

export default component.exports